import {Button, Form, Upload, Input, Modal, Alert, notification} from "antd";
import {MobileOutlined, PhoneOutlined, DashboardOutlined, PictureOutlined} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {ChangeUnitValidation, Validation} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import AuthenticatedForm from "./AuthenticatedForm";
import {useOutletContext} from "react-router-dom";
import DefaultForm from "./DefaultForm";
import AbfaLogo from "../../images/logo.png"
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import ConfirmInfoModal from "../modals/ConfirmInfoModal";
const ChangeUnit = () => {
    const authContext = useContext(AuthContext);
    const outletContext = useOutletContext();
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data)
    const [isLoading, setLoading] = useState(false);
    const [constructionLicenseList, setConstructionLicenseList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [constructionLicenseBase64, setConstructionLicenseBase64] = useState('');
    const [legalFacilitiesList, setLegalFacilitiesList] = useState<UploadFile[]>([]);
    const [legalFacilitiesBase64, setLegalFacilitiesBase64] = useState('');
    //merge-image
    useEffect(() => {
        getMergeImage(constructionLicenseList, (base64) => {

            setConstructionLicenseBase64(base64)
        })
    }, [constructionLicenseList]);
    useEffect(() => {
        getMergeImage(legalFacilitiesList, (base64) => {
            setLegalFacilitiesBase64(base64)
        })
    }, [legalFacilitiesList]);
    const legalFacilitiesProps: UploadProps = {
        fileList: legalFacilitiesList,
        onRemove: file => {
            const index = legalFacilitiesList.indexOf(file);
            const newFileList = legalFacilitiesList.slice();
            newFileList.splice(index, 1);
            setLegalFacilitiesList([]);

        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)
                    setLegalFacilitiesList([newFile]);
                    return  false
                })
            }


            /*  setLegalFacilitiesList([file]);*/

            return false;
        },
    };
    const [previewImage, setPreviewImage] = useState('');

    const constructionLicenseProps: UploadProps = {
        fileList: constructionLicenseList,
        onRemove: file => {
            const index = constructionLicenseList.indexOf(file);
            const newFileList = constructionLicenseList.slice();
            newFileList.splice(index, 1);
            setConstructionLicenseList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {
                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)
                    setConstructionLicenseList([newFile]);
                    return  false
                })
            }



            return false;
        },
    };

    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const handlePrint=(text:string,name:string,traceNumber:string,address:string,orderType:string,mobile:string)=>{
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {
        console.log(values)

        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ?  values.address : data.address ,
            "Description": authContext.authenticated ? values.description : data.description,
            "NewUnit": values.NewUnit ? ConvertPersianToEnglish(values.NewUnit) : null,
            "CurrentUnit": ConvertPersianToEnglish(values.CurrentUnit.toString()),
            "ConstructionLicensePic": constructionLicenseBase64,
            "LegalFacilitiesPic": legalFacilitiesBase64,

        };
        const modalData = {
            ...body,
            CityName: data.city_name,
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal
                data={modalData}
                type={"ChangeUnit"}/>,
            onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })
    }


    const handleRequest=(body: any, values: any)=>{
        setLoading(true)
        Request(Urls.ChangeUnit, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.ChangeUnit,response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.ChangeUnit,response.data.trace_number),data.first_name+" "+data.last_name,response.data.trace_number,body.Address,Text.ChangeUnit,values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    }

    const onFinishFailed = (error: any) => {

    }
    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >

            <AuthenticatedForm validationSchema={ChangeUnitValidation} data={data}/>
            <DefaultForm validationSchema={ChangeUnitValidation} data={data}/>


            <Form.Item rules={[Validation(ChangeUnitValidation)]} initialValue={data.current_units_number}
                       name="CurrentUnit" label={"تعداد واحد فعلی"}>
                <Input disabled={!!data.current_units_number} size="large" placeholder="مثلا ۳"
                       prefix={<DashboardOutlined/>}/>
            </Form.Item>
            <Form.Item rules={[Validation(ChangeUnitValidation)]} name="NewUnit" label={"تعداد واحد جدید"}>
                <Input size="large" placeholder="مثلا ۴"
                       prefix={<DashboardOutlined className="text-gray-50"/>}/>
            </Form.Item>
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد." type="error"/>
            </div>

            <Form.Item requiredMark="optional"
                       label={Texts.constructionLicensePic}
                       name="constructionLicense"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionLicenseProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Form.Item requiredMark="optional"
                       label={Texts.legalFacilitiesPic}
                       name="legalFacilities"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...legalFacilitiesProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>

            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>
        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
    </>
}
export default ChangeUnit;